import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ButtonLink from '../ButtonLink';

const Tag = ({ text, active, className, tagInnerClassName, ...props }) => (
  <li key={text} className={tagInnerClassName}>
    <ButtonLink
      element='a'
      className={classNames(
        active && 'tags__item--active',
        'tags__item',
        className
      )}
      {...props}
    >
      {text}
    </ButtonLink>
  </li>
);

Tag.propTypes = {
  className: PropTypes.string,
  tagInnerClassName: PropTypes.node,
  text: PropTypes.node,
  active: PropTypes.bool,
  ...ButtonLink.propTypes
};

export default Tag;
